import toast from "react-hot-toast";
import { useEffect, useState } from "react";
//
import {
    useFetchAllSchemeMutation,
    useSchemeUserSearchMutation,
} from "../../../features/tenant/scheme/schemeApi";
//
import CustomExport from "../../../components/CustomExport/CustomExport";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
// import { useFetchProductsMutation } from "../../../features/tenant/products/productsApi";
import { useFetchAllUserWalletsMutation } from "../../../features/tenant/schemeWallet/schemeWalletApi";
import { useGetDetailedSchemeListMutation } from "../../../features/tenant/Aqualite/aqualiteApi";
import TenantSlugs from "../../../utils/TenantSlug";

let inputClass =
    "block w-full pl-2 pr-3 border border-gray-300 rounded-lg bg-white text-sm placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors";

const downloadFileFromResponse = (response) => {
    if (!response?.fileLink) {
        toast.error("Something went wrong.");
        console.error("No file link found in response");
        return;
    }

    const link = document.createElement("a");
    link.href = response.fileLink;
    link.setAttribute("download", ""); // let browser pick filename from URL
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

const UserTypeSchemeList = ({ user_type_id = "2" }) => {
    const initialFilters = {
        user_type_id: user_type_id,
        mobile: "",
        user_id: "",
        scheme: "all",
        start_date: "",
        end_date: "",
    };

    const is_aqualite =
        JSON.parse(sessionStorage.getItem("vendorData")).tenant_id ==
        TenantSlugs["aqualite"];

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [allData, setAllData] = useState([]);
    const [csvData, setCsvData] = useState(null);
    const [request, setRequest] = useState(initialFilters);
    const [paginationData, setPaginationData] = useState({
        total_items: 0,
        current_page: 1,
        limit: 10,
        total_pages: 0,
    });

    const [
        fetchAllUserWalletsApi,
        { data: userWalletsData, error: userWalletsError },
    ] = useFetchAllUserWalletsMutation();

    const [
        fetchAllUserWalletsCSVApi,
        { data: userWalletsCSVData, error: userWalletsCSVError },
    ] = useFetchAllUserWalletsMutation();

    const [
        fetchDetailedSchemeListApi,
        {
            data: detailedSchemeListData,
            error: detailedSchemeListError,
            isLoading: detailedSchemeListLoading,
        },
    ] = useGetDetailedSchemeListMutation();

    const [fetchSchemesApi, { data: schemesData, error: schemesError }] =
        useFetchAllSchemeMutation();

    const handleSearch = async (body) => {
        toast.loading("Please wait");

        await fetchAllUserWalletsApi({
            token: sessionStorage.getItem("access_token"),
            slug: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            body: body,
        });

        toast.dismiss();
    };

    const handleFetchUserWalletsForCsv = async () => {
        const newRequest = { ...request };
        newRequest["limit"] = 9999999;
        newRequest["page"] = 1;

        fetchAllUserWalletsCSVApi({
            token: sessionStorage.getItem("access_token"),
            slug: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            body: newRequest,
        });
    };

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
        handleSearch({
            ...request,
            page: pageNumber,
            limit,
        });
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setLimit(newPerPage);
        setPage(1);
        handleSearch({
            ...request,
            page: 1,
            limit: newPerPage,
        });
    };

    const intialize = async () => {
        toast.loading("Please wait");

        await fetchSchemesApi({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                .tenant_id,
        });

        toast.dismiss("Please wait");

        await handleSearch({
            ...request,
            page,
            limit,
        });
    };

    useEffect(() => {
        if (userWalletsCSVData) {
            toast.dismiss();
            setCsvData(
                userWalletsCSVData?.body?.list
                    ? userWalletsCSVData?.body?.list
                    : [],
            );
        }

        if (userWalletsCSVError) {
            toast.dismiss();
            toast.error(userWalletsCSVError.data.message, {
                id: "userWalletsCSVError",
            });
        }
    }, [userWalletsCSVData, userWalletsCSVError]);

    useEffect(() => {
        if (userWalletsData) {
            toast.dismiss();

            setAllData(
                userWalletsData?.body?.list ? userWalletsData?.body?.list : [],
            );

            setPaginationData(
                userWalletsData?.body?.pagination
                    ? userWalletsData?.body?.pagination
                    : {},
            );
        }
        if (userWalletsError) {
            toast.dismiss();
            toast.error(userWalletsError.data.message, {
                id: "userWalletsError",
            });
        }
    }, [userWalletsData, userWalletsError]);

    useEffect(() => {
        if (detailedSchemeListData) {
            toast.dismiss();
            console.log("detailedSchemeListData", detailedSchemeListData);
            downloadFileFromResponse(detailedSchemeListData?.body?.data);
        }

        if (detailedSchemeListError) {
            toast.dismiss();
            toast.error("Something went wrong.", {
                id: "detailedSchemeListError",
            });
            console.log("detailedSchemeListError", detailedSchemeListError);
        }
        if (detailedSchemeListLoading) {
            toast.loading("Processing..", { id: "detailedSchemeListLoading" });
        }
    }, [
        detailedSchemeListData,
        detailedSchemeListError,
        detailedSchemeListLoading,
    ]);

    useEffect(() => {
        intialize();
    }, []);

    const columns = [
        {
            name: "SNo",
            cell: (row, idx) => (page - 1) * limit + Number(idx + 1),
            sortable: true,
            width: "80px",
        },
        {
            name: "Scheme",
            cell: (row) => <strong>{row.scheme_name}</strong>,
            sortable: true,
            width: "180px",
        },
        {
            name: "Name",
            cell: (row) => row.name,
            sortable: true,
            width: "180px",
        },
        {
            name: "Mobile",
            cell: (row) => <strong>{row.mobile}</strong>,
            sortable: true,
            width: "180px",
        },
        {
            name: is_aqualite ? "User/Outlet ID" : "User ID",
            cell: (row) => row.user_id,
            sortable: true,
            width: "180px",
        },
        {
            name: "Firm Name",
            cell: (row) => row.firm_name,
            sortable: true,
            width: "180px",
        },
        {
            name: is_aqualite ? "Overall WSP Earned" : "Overall Points Earned",
            cell: (row) => row.point_earned,
            sortable: true,
            width: "180px",
        },
        {
            name: is_aqualite
                ? "Overall WSP Redeemed"
                : "Overall Points Redeemed",
            cell: (row) => row.point_redeemed,
            sortable: true,
            width: "190px",
        },
        {
            name: is_aqualite
                ? "Overall WSP Balance"
                : "Overall Points Balance",
            cell: (row) => row.point_balance,
            sortable: true,
            width: "180px",
        },
        {
            name: (
                <strong>
                    {is_aqualite
                        ? "Calculated Points/WSP"
                        : "Calculated Points"}
                </strong>
            ),
            cell: (row) => <strong>{row?.total_points || "0.00"}</strong>,
            sortable: true,
            width: "180px",
        },
        {
            name: <strong>Total Scans</strong>,
            cell: (row) => <strong>{row?.total_scans}</strong>,
            sortable: true,
            width: "180px",
        },
        {
            name: "City",
            cell: (row) => row.city,
            sortable: true,
            width: "180px",
        },
        {
            name: "State",
            cell: (row) => row.state,
            sortable: true,
            width: "180px",
        },
        {
            name: "District",
            cell: (row) => row.district,
            sortable: true,
            width: "180px",
        },
        {
            name: "Pincode",
            cell: (row) => row.pincode,
            sortable: true,
            width: "180px",
        },
        ...(is_aqualite
            ? [
                  {
                      name: "SO Name",
                      cell: (row) => row.sales_name,
                      sortable: true,
                      width: "180px",
                  },
                  {
                      name: "SO Mobile",
                      cell: (row) => row.sales_mobile,
                      sortable: true,
                      width: "180px",
                  },
              ]
            : []),

        // {
        //     name: "Created At",
        //     cell: (row) => new Date(row.created_at).toLocaleString(),
        //     sortable: true,
        // },
    ];

    return (
        <>
            <div className="flex w-full bg-gray-200 h-full justify-center">
                <div className="w-full ">
                    <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                        Scheme User Search
                        <LinksComponent />
                    </div>

                    <div className="p-3 w-full">
                        <div className="w-full flex flex-row justify-between items-center mb-3">
                            <CustomExport
                                fetchData={handleFetchUserWalletsForCsv}
                                data={csvData}
                                defaultColumnExport={[
                                    "entity_id",
                                    "template_type",
                                    "template_text",
                                    "receiver_mobile_numbers",
                                    "response_message",
                                    "created_at",
                                ]}
                                filename="user_type_scheme_wallets"
                            />

                            {is_aqualite && (
                                <button
                                    onClick={() => {
                                        if (!detailedSchemeListLoading) {
                                            fetchDetailedSchemeListApi({
                                                token: sessionStorage.getItem(
                                                    "access_token",
                                                ),
                                                tenant_id: JSON.parse(
                                                    sessionStorage.getItem(
                                                        "vendorData",
                                                    ),
                                                ).tenant_id,
                                            });
                                        }
                                    }}
                                    className="btn btn-outline-primary"
                                    style={{
                                        pointerEvents: detailedSchemeListLoading
                                            ? "none"
                                            : "auto",
                                    }}
                                >
                                    {detailedSchemeListLoading
                                        ? "Loading..."
                                        : "Download Detailed Report"}
                                </button>
                            )}
                        </div>

                        <div className="p-3 w-full bg-white shadow rounded-lg">
                            <form
                                className="flex flex-row gap-4 w-full items-end justify-center p-2"
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    setPage(1);
                                    handleSearch({
                                        ...request,
                                        page: 1,
                                        limit,
                                    });
                                }}
                            >
                                <div className="relative searchin w-full">
                                    <label className="block text-sm font-medium text-gray-700">
                                        Mobile
                                    </label>
                                    <input
                                        type="text"
                                        id="default-search"
                                        className={`${inputClass}`}
                                        placeholder="Mobile ..."
                                        value={request.mobile}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return {
                                                    ...prevState,
                                                    mobile: newValue,
                                                };
                                            });
                                        }}
                                    />
                                </div>

                                <div className="relative searchin w-full">
                                    <label className="block text-sm font-medium text-gray-700">
                                        User ID
                                    </label>
                                    <input
                                        type="text"
                                        id="default-search"
                                        className={`${inputClass}`}
                                        placeholder="User ID ..."
                                        value={request.user_id}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return {
                                                    ...prevState,
                                                    user_id: newValue,
                                                };
                                            });
                                        }}
                                    />
                                </div>

                                <div className="space-y-2 w-full">
                                    <label className="block text-sm font-medium text-gray-700">
                                        Scheme
                                    </label>

                                    <select
                                        type="text"
                                        id="default-search"
                                        className={`${inputClass}`}
                                        placeholder="Scheme..."
                                        value={request.scheme}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return {
                                                    ...prevState,
                                                    scheme: newValue,
                                                };
                                            });
                                        }}
                                    >
                                        <option value="all">All Schemes</option>
                                        {schemesData?.body?.data?.map(
                                            (item) => {
                                                return (
                                                    <option value={item.id}>
                                                        {item.name}
                                                    </option>
                                                );
                                            },
                                        )}
                                    </select>
                                </div>

                                <div className="relative searchin w-full">
                                    <label className="block text-sm font-medium text-gray-700">
                                        Start Date
                                    </label>
                                    <input
                                        type="date"
                                        id="default-search"
                                        className={`${inputClass}`}
                                        placeholder="Start Date ..."
                                        value={request.start_date}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return {
                                                    ...prevState,
                                                    start_date: newValue,
                                                };
                                            });
                                        }}
                                    />
                                </div>

                                <div className="relative searchin w-full">
                                    <label className="block text-sm font-medium text-gray-700">
                                        End Date
                                    </label>
                                    <input
                                        type="date"
                                        id="default-search"
                                        className={`${inputClass}`}
                                        placeholder="End Date ..."
                                        value={request.end_date}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return {
                                                    ...prevState,
                                                    end_date: newValue,
                                                };
                                            });
                                        }}
                                    />
                                </div>

                                <div className="relative searchin">
                                    <button
                                        className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 px-4 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
                                        type="submit"
                                    >
                                        <svg
                                            className="w-4 h-4"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                            />
                                        </svg>
                                        Search
                                    </button>
                                </div>
                            </form>

                            <DataTableComponent
                                keyField={(row) => row.SNo}
                                columns={columns}
                                data={allData}
                                // loading={loading}
                                totalRows={paginationData?.total_items}
                                handlePerRowsChange={handlePerRowsChange}
                                handlePageChange={handlePageChange}
                            >
                                <div className="flex m-2 space-x-2 justify-end"></div>
                            </DataTableComponent>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default UserTypeSchemeList;
